export let normalRewardAry:number[] = [
    0,
    5,
    50,
    5000,
    50000,
    500000,
    1000000,
]

export let goldRewardAry:number[] = [
    0,
    80000,
    580000,
    880000,
    2880000,
    5000000
]

export let normalRewardNames:string[] = [
    "未中奖",
    "叫花子奖",
    "鼓励奖",
    "四等奖",
    "三等奖",
    "二等奖",
    "一等奖",
]
